import { AbstractLayer } from './abstract-layer';
import { ImageLayer } from './image-layer';
import { TextLayer } from './text-layer';
import { SVGLayer } from './svg-layer';
import { Subscription, BehaviorSubject } from 'rxjs';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { LabelData } from 'src/app/data/configurator/label/label.data';
import { LabelEvent } from '../events/label.event';
import { WingdingLayer } from './wingding-layer';
import { SquareLayer } from './square-layer';
import { CircleLayer } from './circle-layer';
import { TriangleLayer } from './triangle-layer';
import { LineLayer } from './line-layer';

declare const fabric: any;

export class Label {

  static PREVIEW_RATIO:number = 1;

  private _data: LabelData;
  private _stage: any;

  private _rotation: number = 0;

  private _layers: Array<AbstractLayer>;

  private _preview: HTMLCanvasElement;
  private _previewStage: any;
  private _previewTimeout: any;

  private _labelSubscription: Subscription;

  /**
   * Contructor
   */
  constructor(data: LabelData) {
    this._data = data;
    this._layers = [];

    this._preview = document.createElement("canvas");
    this._previewStage = new fabric.StaticCanvas(this._preview);


    this._labelSubscription = this._data.onChange.subscribe({
      next: (event: LabelEvent) => {
        // console.log("Label.LabelData.onChange()", event);
        if (event.type == LabelEvent.CHANGE) {
          this.updateView();
        } else if (event.type == LabelEvent.ADD_LAYER) {
          // this.addLayer(event.data);
        } else if (event.type == LabelEvent.REMOVE_LAYER) {
          this.removeLayer(event.data);
        } else if (event.type == LabelEvent.REORDER_LAYERS) {
          this.reorderLayers();
        } else if (event.type == LabelEvent.INIT_EMPTY) {
          this.redraw();
        } else {
          // this.redraw();
          // this.drawLayers();
        }
      }
    });
  }

  /**
   * Layout template
   */
  public redraw():void {

    // console.log("Label.redraw()");

    this.update();


    this._previewStage.setWidth(this._data.pixelsWidth * Label.PREVIEW_RATIO);
    this._previewStage.setHeight(this._data.pixelsHeight * Label.PREVIEW_RATIO);

    this._previewStage.clear();
    this._previewStage.setBackgroundColor('rgba(255, 255, 255, 1)');

    for (let l of this.layers) {
      // console.log("\t",l, l.preview)
      if (l && l.preview) {
        this._previewStage.add(l.preview);
      }
    }

    this._previewStage.setZoom(Label.PREVIEW_RATIO);
  }

  /**
   * Rotate
   */
  set rotation(angle:number) {
    this._rotation = angle;

    this.update();
  }

  /**
   * Draw
   */
  public update(): void {
    for (let l of this._layers) {
      if (l) {
        l.currentCanvasAngle = this._rotation;
      }
    }
  }

  /**
   * Template
   */
  //get template(): any {
    //return this._data.templateData.masker;
  //}

  /**
   * Get preview stage
   */
  get previewStage(): any {
    return this._previewStage;
  }

  /**
   * Get preview
   */
  get preview(): any {
    return this._preview;
  }

  /**
   * Stage
   */
  set stage(value: any) {
    this._stage = value;

    for (let l of this._layers) {
      if (l) {
        l.stage = this._stage;
      }
    }
  }

  get stage(): any {
    return this._stage;
  }

  /**
		 * Add a layer
		 */
  public addLayer(layerData: LayerData):Promise<boolean> {
    return new Promise((resolve, reject) => {
      let layer:AbstractLayer;

      // console.log("Label.addLayer()",layerData);

      switch (layerData.type) {
        case LayerData.IMAGE:
          layer = new ImageLayer(layerData, this._stage);
          break;
        case LayerData.TEXT:
          layer = new TextLayer(layerData, this._stage);
          break;
        case LayerData.SVG_SHAPE:
          layer = new SVGLayer(layerData, this._stage);
          break;
        case LayerData.SQUARE_SHAPE:
          layer = new SquareLayer(layerData, this._stage);
          break;
        case LayerData.CIRCLE_SHAPE:
          layer = new CircleLayer(layerData, this._stage);
          break;
        case LayerData.TRIANGLE_SHAPE:
          layer = new TriangleLayer(layerData, this._stage);
          break;
        case LayerData.LINE_SHAPE:
          layer = new LineLayer(layerData, this._stage);
          break;
        case LayerData.WINGDINGS_SHAPE:
          layer = new WingdingLayer(layerData, this._stage);
          break;
      }

      if (layer) {
        layer.labelData = this._data;

        this._layers.push(layer);


        this._layers.sort((l1: AbstractLayer, l2: AbstractLayer) => {
          return l1.data.index - l2.data.index;
        });

        layer.draw().then(() => {
          if (layerData.source == LayerData.DESIGN) {
            this.redraw();
          } else if (layerData.source == LayerData.CREATION) {
            this.centerLayerX(layer);
            this.centerLayerY(layer);
            this.redraw();
          } else if (layer.data.source == LayerData.EXCEL) {
            this.centerLayerX(layer);
            this.centerLayerY(layer);
            this.redraw();
          } else if (layer.data.source == LayerData.DUPLICATION) {
            this.redraw();
          }
          resolve(true);
        });
      }
    });

    // } else if (layer.data.source == LayerData.CLIPBOARD) {
    //   ProjectData.instance.selectLayer(layer.data, true);
    // } else if (layer.data.source == LayerData.EXCEL) {
    //   ProjectData.instance.selectLayer(layer.data, true);
    //   stage.dispatchEvent(new LayerEvent(LayerEvent.CENTER_VERTICALLY, layer.data));
    //   stage.dispatchEvent(new LayerEvent(LayerEvent.CENTER_HORIZONTALLY, layer.data));
    // }

  }

  /**
		 * Remove a layer
		 */
  public removeLayer(layerData: LayerData): void {
    for (var i: number = 0; i < this._layers.length; i++) {
      if (this._layers[i].data == layerData) {
        this._layers.splice(i, 1);
        break;
      }
    }

    this._previewStage.forEachObject((obj) => {
      if (obj.data == layerData) {
        this._previewStage.remove(obj);
      }
    });

    this.updateView();
  }

  /**
		* Add a layer
	 */
  public reorderLayers(): void {
    this._layers.sort((l1: AbstractLayer, l2: AbstractLayer) => {
      return l1.data.index - l2.data.index;
    });

    this.redraw();
  }

  /**
   * Update view
   */
  updateView(): void {

    // console.log("Template.updateView()", !!this._previewStage);
    if (this._previewStage) {
      if (this._previewTimeout) {
        clearTimeout(this._previewTimeout);
      }
      this._previewTimeout = setTimeout(() => {
        this._previewStage.renderAll();
        this._previewTimeout = null;
      }, 100);
    }
  }

  /**
  * Get layers
  */
  get layers(): Array<AbstractLayer> {
    return this._layers;
  }

  /**
   * Center layer vertically
   */
  public centerLayerY(layer: AbstractLayer): void {

    if (layer.data.rotation % 360 == 0) {
      layer.data.y = (this._data.pixelsHeight - layer.display.height * layer.display.scaleY) / 2;
    } else if (layer.data.rotation % 270 == 0) {
      layer.data.y = (this._data.pixelsHeight - layer.display.width * layer.display.scaleX) / 2;
    } else if (layer.data.rotation % 180 == 0) {
      layer.data.y = (this._data.pixelsHeight + layer.display.height * layer.display.scaleY) / 2;
    } else if (layer.data.rotation % 90 == 0) {
      layer.data.y = (this._data.pixelsHeight + layer.display.width * layer.display.scaleX) / 2;
    }
  }

  /**
  * Center layer horizontally
  */
  public centerLayerX(layer: AbstractLayer): void {

    if (layer.data.rotation % 360 == 0) {
      layer.data.x = (this._data.pixelsWidth - layer.display.width * layer.display.scaleX) / 2;
    } else if (layer.data.rotation % 270 == 0) {
      layer.data.x = (this._data.pixelsWidth + layer.display.height * layer.display.scaleY) / 2;
    } else if (layer.data.rotation % 180 == 0) {
      layer.data.x = (this._data.pixelsWidth + layer.display.width * layer.display.scaleX) / 2;
    } else if (layer.data.rotation % 90 == 0) {
      layer.data.x = (this._data.pixelsWidth - layer.display.height * layer.display.scaleY) / 2;
    }
  }


  /**
   * Cleanup
   */
  public cleanup(): void {
    if (this._labelSubscription) {
      this._labelSubscription.unsubscribe();
      this._labelSubscription = null;
    }
  }
}
